<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Generador de codigos de barra</h3>
      <v-row>
        <v-col md="4" cols="12">
          <h5>Seleccione los productos para generar sus codigos de barra</h5>
          <v-row>
            <v-col md="8">
              <v-autocomplete
                v-model="productoSelected"
                :items="global_prod"
                item-value="id"
                item-text="Nombre"
                label="Productos"
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    {{ data.item.Nombre }} - {{ data.item.Price }}
                    {{ data.item.Moneda }}<br />
                    <b>Codigo barras: {{ data.item.CodigoBarras }}</b>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col md="4">
              <v-btn color="primary" @click="addProduct()" block>Agregar</v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="8" cols="12"> </v-col>
        <v-col md="12" cols="12">
          <v-row>
            <v-col md="4" cols="12">
              <h5>Productos a generar</h5>

              <v-list two-line>
                <template v-for="(item, index) in productosSelected">
                  <v-list-item :key="index">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.Nombre }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn @click="deleteProd(index)" color="red" dark>
                        Eliminar
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
            </v-col>
            <v-col md="8" cols="12">
              <v-row>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="columnas"
                    label="Columnas por hoja"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="filas"
                    label="Filas por hoja"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="w"
                    label="Ancho de etiqueta (Pulgadas)"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="h"
                    label="Alto de etiqueta (Pulgadas)"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="codeByprod"
                    label="Numero de etiquetas por producto"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="colInit"
                    label="Inicia en la columna:"
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    v-model="filaInit"
                    label="Inicia en la fila:"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-btn color="primary" @click="generatePdf" block
                >Generar Codigos</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style></style>

<script>
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
import CodigosBarra from "../../../clases/PdfMakers/CodigosBarra.js";
export default {
  name: "GeneradorCodigos",
  components: {},
  props: [],
  data() {
    return {
      productosSelected: [],
      productoSelected: null,
      columnas: 3,
      filas: 10,
      h: 1,
      w: 2.6,
      codeByprod: 1,
      colInit: 1,
      filaInit: 1,
    };
  },
  methods: {
    addProduct() {
      let prod = this.$pgsHelper.getById(
        this.global_prod,
        "id",
        this.productoSelected
      );
      if (prod) {
        let exist = this.$pgsHelper.getById(
          this.productosSelected,
          "id",
          this.productoSelected
        );
        if (!exist) {
          this.productosSelected.push(prod);
        }
      }
    },
    deleteProd(index) {
      this.productosSelected.splice(index, 1);
    },
    async generatePdf() {
      let mainData = {
        /*FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),*/

        data: this.productosSelected,
      };
      let codes = new CodigosBarra({
        columnas: Number(this.columnas),
        filas: Number(this.filas),
        h: Number(this.h),
        w: Number(this.w),
        codeByprod: Number(this.codeByprod),
        colInit: Number(this.colInit),
        filaInit: Number(this.filaInit),
      });

      let docData = await codes.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },
  },
  computed: {
    global_prod() {
      let prod = this.$store.getters.getProductos;
      let origenes = this.$store.getters.getOrigenes;
      let productos = prod;
      let prodPrices = [];

      productos.forEach((producto) => {
        let invData = [];
        let matchCount = 0;
        if (producto.Tipo == "Producto" || producto.Tipo == "Producto-SSal") {
          origenes.forEach((origen, index) => {
            let origenesNames = this.$store.getters.getCentrosConsumo;
            let itemIndex = this.$_.findIndex(origenesNames, {
              id: origen.Origen,
            });
            origen.nombreOrigen = origenesNames[itemIndex]?.Nombre;
            let OrProd = Object.entries(origen.Productos);
            let productMatch = "";
            OrProd.forEach((oProducto) => {
              if (oProducto[0] == producto.id) {
                productMatch = oProducto;
                matchCount++;
                //this.$pgsHelper.log(oProducto[1]);
                /* let pro = producto;
                    let idCompuesto = pro.id+'_'+origen.Origen;
                    pro.Existencia = oProducto[1].Stock;
                    pro.compId = idCompuesto;
                    newProductos.push({id:idCompuesto ,Existencia: oProducto[1].Stock,...producto});*/
              }
            });
            if (productMatch != "") {
              prodPrices.push({
                Origen: origen.Origen,
                Price: productMatch[1].PV,
                NombreOrigen: origen.nombreOrigen,
                ...producto,
              });
            }
          });
        } else {
          prodPrices.push({
            Origen: "",
            Price: producto.Precio,
            NombreOrigen: "",
            ...producto,
          });
        }

        producto.existenciaPrecio = invData;
        producto.existenciaData = invData;
      });

      let data = prodPrices;
      /*let claims = this.$route.params.user.tokenResult.claims;
      if (claims?.Data?.Only?.AYB) {
        data = JSON.parse(JSON.stringify(productos)).filter((prod) => {
          if (prod.Departamentos && prod.Departamentos.includes('Restaurante')) {
            return true;
          } else {
            return false;
          }
        });
      }*/
      let sortReservations = this.$_.orderBy(data, "Nombre", "asc");

      return sortReservations;
    },
  },
  watch: {},
  mounted() {},
  created() {},
};
</script>
